import React from "react";

export default function PrafulRedirect() {
  return <div>Login Redirect</div>;
}
